import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PRICE, PRODUCT } from '../data/content';
export function PricingSection() {
  return <section id="oferta" aria-labelledby="precio" className="bg-royal" data-id="element-106" data-mp="1eg5n6d6qwcc6">
      <div className="mx-auto max-w-page px-3 py-6 text-center sm:px-6 sm:py-8" data-id="element-107" data-mp="1j9qn4arwfge0">
        <Reveal data-id="element-108" data-mp="1nbbvpjxeh8ie">
          <h2 id="precio" className="font-display text-lg font-black uppercase leading-tight text-white sm:text-2xl lg:text-3xl" data-id="element-109" data-mp="1n9r2pyqqhxmn">
            Oferta especial — Sistema completo 6 en 1
          </h2>
          <p className="mt-1 text-[0.8rem] font-bold text-gold sm:text-[0.95rem]" data-id="element-110" data-mp="1x6vqg308a15k">
            Comienza hoy desde cero y avanza a tu ritmo.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mx-auto mt-3 max-w-lg rounded-xl border-2 border-gold bg-navy p-3 sm:p-5" data-id="element-111" data-mp="2w9xpvgdjcur">
          <h3 className="font-display text-base font-black uppercase leading-tight text-gold sm:text-xl" data-id="element-112" data-mp="1mgogxhl8plni">
            📘 {PRODUCT}
          </h3>
          <p className="font-sans text-[0.95rem] font-extrabold uppercase text-white sm:text-lg" data-id="element-113" data-mp="1hp6f6rbe7h1h">
            6 Módulos + 5 Bonos
          </p>
          <p className="mt-1.5 rounded bg-gold/12 px-3 py-1 text-[0.72rem] font-extrabold uppercase text-gold sm:text-[0.82rem]" data-id="element-114" data-mp="17rs99ln3ianf">
            🎁 Bonos valorados en {BONUS_VALUE}
          </p>

          <p className="mt-2 text-[0.7rem] font-extrabold uppercase tracking-[0.18em] text-white sm:text-[0.8rem]" data-id="element-115" data-mp="25d6dccb1a9q3">
            🔥 Oferta especial
          </p>
          <p className="text-[0.62rem] font-bold uppercase tracking-[0.24em] text-ivory sm:text-[0.7rem]" data-id="element-116" data-mp="1vg1no2hzbw4j">
            Hoy:
          </p>
          <p className="font-display text-4xl font-black leading-none text-gold sm:text-5xl" data-id="element-117" data-mp="1ri3xoxgdx603">
            {PRICE}
          </p>
          <p className="mt-1 text-[0.64rem] font-semibold uppercase tracking-wide text-ivory sm:text-[0.72rem]" data-id="element-118" data-mp="g02wa2wl0eqz">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <div className="mt-3 flex flex-col items-center gap-1.5" data-id="element-119" data-mp="mgkv1trwv280">
            <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-120" data-mp="meryx8exc0e9">
              🚀 SÍ, QUIERO {PRODUCT} POR {PRICE}
            </CtaButton>
            <p className="flex flex-wrap items-center justify-center gap-x-2 text-[0.64rem] font-bold uppercase tracking-wide text-ivory sm:text-[0.72rem]" data-id="element-121" data-mp="ci5g0p65rjev">
              Acceso Inmediato
              <span aria-hidden="true" data-id="element-122" data-mp="3hqhup83i9ty">•</span>
              <span className="flex items-center gap-1" data-id="element-123" data-mp="3jjpo7ug303j">
                <ShieldCheckIcon size={12} className="text-gold" data-id="element-124" data-mp="3kyqehc15yu3q" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}